/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Hero_LeadInputs */

const en_hub_hero_lead = /** @type {(inputs: Hub_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Bystep plan leaves as native files for the tool you run — front matter, task ids, milestones, scenarios — and comes back the same way. No lock-in, no re-typing.`)
};

const id_hub_hero_lead = /** @type {(inputs: Hub_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana Bystep keluar sebagai berkas asli alat Anda — front matter, id task, milestone, skenario — dan bisa masuk kembali lewat jalur yang sama. Tanpa kunci vendor, tanpa mengetik ulang.`)
};

/**
* | output |
* | --- |
* | "A Bystep plan leaves as native files for the tool you run — front matter, task ids, milestones, scenarios — and comes back the same way. No lock-in, no re-ty..." |
*
* @param {Hub_Hero_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_hero_lead = /** @type {((inputs?: Hub_Hero_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Hero_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_hero_lead(inputs)
	return en_hub_hero_lead(inputs)
});